import { AppModal } from '@app/components/AppModal';
import AppAlert from '@app/components/AppAlert';
import { useState } from 'react';
import { validateAndCreateManyParrainages } from '@app/api/data/parrainages-reconductions-modifie';
import AppLoading from '@app/components/AppLoading';

type props = {
    onSuccess: () => void;
    idToUpdate: number[];
    open: boolean;
    onClose: () => void;
};

export const ValidateReconductions = ({
    idToUpdate,
    onSuccess,
    open,
    onClose,
}: props) => {
    const [loading, setLoading] = useState<boolean>(false);

    const submit = async () => {
        setLoading(true);
        try {
            await validateAndCreateManyParrainages(idToUpdate);
            onSuccess();
            onClose();
        } catch (error) {
            console.error('Erreur lors de la validation:', error);
            // Vous pouvez ajouter une notification d'erreur ici si nécessaire
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };

    return (
        <AppModal
            handleSubmit={submit}
            icon="CheckIcon"
            title={`Validation des reconductions`}
            submitText="Valider"
            submitIcon="CheckIcon"
            open={open}
            onClose={onClose}
        >
            <div className="flex min-w-[400px] flex-col">
                <label className="mb-4">
                    {idToUpdate.length} reconduction(s) à valider
                </label>
                {loading ? (
                    <AppLoading />
                ) : (
                    <AppAlert
                        message={{
                            color: 'warning',
                            title: 'Validation des reconductions',
                            text: 'Valider les reconductions sélectionnées ?',
                        }}
                    />
                )}
            </div>
        </AppModal>
    );
};
export default ValidateReconductions;

